package com.htmlagent.site.i18n

import androidx.compose.runtime.staticCompositionLocalOf

/**
 * The texts in force, for any composable: `LocalStrings.current.chat.placeholder`.
 *
 * `static` because the whole tree is rebuilt when it changes, which is what switching language
 * means; there is nothing to gain from tracking reads one by one.
 */
val LocalStrings = staticCompositionLocalOf<Strings> { SpanishStrings }
